import {useEffect} from "react";
import {usePage} from "@inertiajs/react";

export default function useGlobalUserDataLayer() {
    const {props} = usePage();
    const {user = {}} = props;

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        const item = window.dataLayer.find(item => item.event === 'userId') ?? {};
        const {event = null} = item;
        if (user.id !== null && event === null) {
            window.dataLayer.push({
                'event': 'userId',
                'user_id': `${user.id}`
            });
        }
    }, [user.id]);
}
